import { newButton, newContainer, newDraft, newEmbed, newField, newRow, newSection, newSeparator, newText, uid } from '../../../src/shared/factory.js';
import type { Draft } from '../../../src/shared/types.js';

/** Пример, который видит пользователь при первом открытии редактора. */
export function starterClassic(): Draft {
  const d = newDraft('classic');
  d.content = 'Привет! Это **Embed Studio** - редактируйте всё слева, предпросмотр обновляется сразу.';
  const e = newEmbed();
  e.author.name = 'Embed Studio';
  e.title = 'Добро пожаловать на сервер';
  e.description = [
    '## Правила в двух словах',
    '- Уважайте друг друга',
    '- Без спама и рекламы',
    '- Спойлеры прячьте вот так: ||сюрприз||',
    '',
    '> Вопросы - в <#000000000000000000>',
    '-# Обновлено <t:1767225600:R>',
  ].join('\n');
  const f1 = newField();
  f1.name = '📅 Ивенты';
  f1.value = 'Каждую пятницу';
  const f2 = newField();
  f2.name = '🎮 Игры';
  f2.value = 'Minecraft, CS2';
  const f3 = newField();
  f3.name = '💬 Язык';
  f3.value = 'Русский';
  e.fields = [f1, f2, f3];
  e.footer.text = 'Нажмите кнопку ниже, чтобы получить роль';
  e.timestamp = new Date().toISOString();
  d.embeds = [e];
  const row = newRow(false);
  const b1 = newButton('success');
  b1.label = 'Получить роль';
  b1.emoji = '✅';
  const b2 = newButton('link');
  b2.label = 'Сайт';
  b2.url = 'https://discord.com';
  row.items = [b1, b2];
  d.rows = [row];
  return d;
}

export function starterV2(): Draft {
  const d = newDraft('v2');
  const c = newContainer();
  const s = newSection();
  s.texts = [newText('## Components V2\nНовый формат сообщений Discord: блоки текста, секции с миниатюрами, галереи и кнопки внутри карточки.')];
  s.accessory = { type: 'thumbnail', url: 'https://cdn.discordapp.com/embed/avatars/0.png', description: '', spoiler: false };
  const row = newRow(false);
  const b = newButton('primary');
  b.label = 'Подробнее';
  row.items = [b];
  c.children = [s, newSeparator(), newText('- До **40** компонентов\n- До **4000** символов текста\n-# Контейнер можно сделать спойлером'), row];
  d.v2 = [c, { id: uid(), type: 'text', content: '-# Текст можно размещать и вне контейнеров' }];
  return d;
}
